<hr />
<h2 class="mb-4">Payment Information</h2>

<div class="mb-3" *ngIf="(credit !== 0)">
  <p-checkbox id="applyCreditOnAccount" [label]="'Apply Credit on Account: ' + minOfCreditAndTotal"
      [binary]='true' [(ngModel)]="applyCredit" name="applyCreditOnAccount" (click)="applyCreditUpdated()">
  </p-checkbox>
  <small class="ms-3 mt-2">Account credit will be applied to the total at the time of payment. Any
      remaining amount due will be paid with the payment method selected below.</small>
</div>

<ng-container [formGroup]="form">

  <p-radioButton id="paynow" label="Pay Now" [value]="'payNow'" formControlName="paymentMode"></p-radioButton>
  <p-radioButton id="paylater" label="Pay Later" [value]="'payLater'" formControlName="paymentMode" class="ms-5"></p-radioButton>

  <div *ngIf="showPaymentMethods" class="mt-2 ms-5">
    <div *ngFor="let m of methods" class="mt-1">
      <p-radioButton [label]="m.description" [value]="m.id" id="{{'pm.' + m.id}}" (onClick)="choosePM(m)" 
      [formControlName]="m.disabled ? 'disabledRadio' : 'selectedMethod'"></p-radioButton>
    </div>

    <div class="mt-2 ms-4" *ngIf="showNewPaymentMethod">
      <p-radioButton label="Credit Card" [value]="0" id="newPaymentWithCreditCard" (onClick)="chooseNewPaymentMethod()" formControlName="newPaymentMethod"></p-radioButton>
      &nbsp;
      <p-radioButton label="ACH" [value]="1" id="newPaymentWithACH" formControlName="newPaymentMethod" (onClick)="chooseNewPaymentMethod()"></p-radioButton>
    </div>

    <div class="mt-3 ms-3" formGroupName="cc" *ngIf="showNewPaymentMethod && form.controls.newPaymentMethod.value === 0">
      <div class="row">
        <div class="col-7">
          <label for="description">Description</label>
          <input id="description" appScrText placeholder="Description" formControlName="description" maxlength="30" />
        </div>
      </div>
      <div class="row">
        <div class="col-3 mt-3">
          <label for="cardType" class="required">Card Type</label>
          <p-dropdown appDd [filter]="true" [options]="cardTypes" placeholder="Card Type" #cardType formControlName="cardType" id="cardType"></p-dropdown>
          <app-error-msg [fg]="form" fieldName="cc.cardType" fieldLabel="Card Type"></app-error-msg>
        </div>
      </div>
      <div class="row">
        <div class="col-4 mt-3">
          <label for="creditCardNumber" class="required">Credit Card Number</label>
          <input appScrText appCcValidator [cardType]="form.get('cc.cardType')?.value"
            [mask]="form.get('cc.cardType')?.value === 'Amex' ? '0000 000000 00000' : '0000 0000 0000 0000'" [validation]="false" #creditCardNumber placeholder="Credit Card Number"
            id="creditCardNumber" formControlName="creditCardNumber" />
          <app-error-msg [fg]="form" fieldName="cc.creditCardNumber" fieldLabel="Credit Card Number"></app-error-msg>
        </div>
      </div>

      <h5 class="mt-3">Expiration Date</h5>
      <div class="row">
        <div class="col-3">
          <label for="expirationMonth" class="required">Month</label>
          <p-dropdown appDd [filter]="true" [options]="months" placeholder="Month" formControlName="expirationMonth" #month appCcExpirationValidator
            [year]="form.get('cc.expirationYear')?.value" id="expirationMonth"></p-dropdown>
          <app-error-msg [fg]="form" fieldName="cc.expirationMonth" fieldLabel="Month"></app-error-msg>
        </div>
        <div class="col-2">
          <label for="expirationYear" class="required">Year</label>
          <p-dropdown appDd [filter]="true" [options]="years" placeholder="Year" formControlName="expirationYear" #year appCcExpirationValidator
            [month]="form.get('cc.expirationMonth')?.value" id="expirationYear"></p-dropdown>
          <app-error-msg [fg]="form" fieldName="cc.expirationYear" fieldLabel="Year"></app-error-msg>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-4">
          <label id="cvv" for="cvv" class="required">Card Verification Value (CVV)
            <sup><i class="fa fa-circle-info large" style="color: #004381; margin-left: .1em;" pTooltip="For your safety and security, we require that you enter your card verification number.
                For Visa, MasterCard, and Discover cards, the card verification number is the last 3 digit number located on the back of your 
                card on or above your signature line. For an American Express card, it is the 4 digits on the front above the end of your card number." tooltipPosition="top"
              tooltipStyleClass="toolCardData" appendTo="body"></i></sup>
          </label>
        </div>
      </div>
      <div class="row">
        <div class="col-3 mb-3">
          <!-- <label class="required">Card Verification</label> -->
          <input appScrText appCvvValidator mask="9999" [validation]="false" [cardType]="form.get('cc.cardType')?.value" placeholder="CVV" formControlName="cvv" #cvv id="cvv" />
          <app-error-msg [fg]="form" fieldName="cc.cvv" fieldLabel="Card Verification Value (CVV)"></app-error-msg>
        </div>
      </div>
      <div class="row">
        <div class="col-5 mb-3">
          <p-checkbox label="Add Card to Profile after Checkout" formControlName="addCardToProfileAfterCheckout" (onChange)="addToProfileUpdate($event)" [binary]="true"
            id="addCardToProfileAfterCheckout"></p-checkbox>
          <div class="ms-4 mt-2">
            Check this box if you wish to update your credit card profile with the information above.
          </div>
          <div class="ms-5 mt-2">
            <p-checkbox label="Set as Default" formControlName="default" [binary]="true" id="default"></p-checkbox>
            <div class="ms-4 mt-2">
              If you set this new credit card as the default, all your
              Auto-renew orders will be charged using the new credit
              card profile information.
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-3 ms-3" formGroupName="ach" *ngIf="showNewPaymentMethod && form.controls.newPaymentMethod.value === 1">
      <div>
        <div class="row">
          <div class="col-8 mb-2">
            You must notify your bank that iconectiv is approved to electronically debit your
            account for payments to the Short Code Registry. Please provide your bank with iconectiv's identification
            code ({{achIdentificationCode}}), which will be associated with these debited payments. Failure to do so may result in the
            payment being declined and the order being reverted to an unpaid state.
          </div>
        </div>
        <div class="row">
          <div class="col-7 mb-3">
            <label  for="accountOwnerName" id="accountOwnerNameLabel"class="required">Account Owner Name</label>
            <input class="form-control" appScrText id="accountOwnerName" #accountOwnerName formControlName="accountOwnerName" placeholder="Account Owner Name" maxlength="80" />
            <app-error-msg [fg]="form" fieldName="ach.accountOwnerName" fieldLabel="Account Owner Name"></app-error-msg>
          </div>
        </div>
        <div class="row">
          <div class="col-3 mb-3">
            <label for="accountTypesDD" class="d-block" class="required">Account Type</label>
            <p-dropdown appDd [options]="accountTypes" [filter]="true" name="a`ccountType" id="accountTypesDD" placeholder="Account Type" formControlName="accountType" #accountType>
            </p-dropdown>
            <app-error-msg [fg]="form" fieldName="ach.accountType" fieldLabel="Account Type"></app-error-msg>
          </div>
        </div>
        <div class="row">
          <div class="col-7 mb-3">
            <label id="descriptionLabel" for="description">Description</label>
            <input id="description" appScrText placeholder="Description" formControlName="description" maxlength="80" />
          </div>
        </div>
        <div class="row">
          <div class="col-4 mb-3">
            <label id="accountNumberLabel" for="accountNumber" class="required">Account Number</label>
            <input class="form-control" appScrText maxlength="{{MaxLen.AccountNumber}}" minlength="6" formControlName="accountNumber" placeholder="Account Number" appNumericOnly
              id="accountNumber" #accountNumber />
            <app-error-msg [fg]="form" fieldName="ach.accountNumber" fieldLabel="Account Number" [customLengthMessage]="true"
              customLengthMessageContent="Account Number is invalid. Must be between 6-17 digits.">
            </app-error-msg>
          </div>
        </div>
        <div class="row">
          <div class="col-4 mb-3">
            <label id="confirmAccountNumberLabel" for="confirmAccountNumber" class="required">Confirm Account Number</label>
            <input class="form-control" appScrText maxlength="{{MaxLen.AccountNumber}}" minlength="6" #confirmAccountNumber placeholder="Confirm Account Number" appNumericOnly
              formControlName="confirmAccountNumber" id="confirmAccountNumber" />
            <app-error-msg [fg]="form" fieldName="ach.confirmAccountNumber" fieldLabel="Confirm Account Number" [customLengthMessage]="true"
              otherFieldLabel="Account Number"
              customLengthMessageContent="Confirm Account Number is invalid. Must be between 6-17 digits.">
            </app-error-msg>
            <div>
              <span class="inline-error-text" *ngIf="showAccountMismatchError">
                Value must match the value entered in Account Number
              </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-7 mb-3">
            <label id="routingNumberLabel" for="routingNumber" class="required">Routing Number (9 Digits)</label>
            <input class="form-control" appScrText appCheckSum appNumericOnly #routingNumber formControlName="routingNumber" placeholder="Routing Number" minlength="9"
              id="routingNumber" maxlength="{{MaxLen.RoutingNumber}}" />
            <app-error-msg [fg]="form" fieldName="ach.routingNumber" fieldLabel="Routing Number"></app-error-msg>
          </div>
        </div>
        <div class="row">
          <div class="col-7 mb-3">
            <label id="bankNameLabel" for="bankName" class="required">Bank Name</label>
            <input class="form-control" appScrText placeholder="Bank Name" #bankName id="bankName" formControlName="bankName" maxlength="40" />
            <app-error-msg [fg]="form" fieldName="ach.bankName" fieldLabel="Bank Name"></app-error-msg>
          </div>
        </div>
        <div class="row">
          <div class="col-4 mb-3">
            <label id="maxPaymentLimitLabel" for="maxPaymentLimit" class="required">Maximum Payment Limit</label>

            <p-inputNumber appIn #limit mode="currency" currency="USD" locale="en-US" [min]="0.01" formControlName="limit" [max]="achMaxPaymentLimit"
              placeholder="Maximum Payment Limit" id="maxpaymentLimit"></p-inputNumber>
            <app-error-msg [fg]="form" fieldName="ach.limit" fieldLabel="Maximum Payment Limit"></app-error-msg>
          </div>
        </div>
        <div class="row">
          <div class="col-5 mb-3">
            <p-checkbox label="Add Payment Method to Profile after Checkout" formControlName="addToProfileAfterCheckout" (onChange)="addToProfileUpdate($event)" [binary]="true"
              id="addToProfileAfterCheckout">
            </p-checkbox>
            <div class="ms-4 mt-2">
              Check this box if you wish to update your payment methods on file with the information above.
            </div>
            <div class="ms-5 mt-2">
              <p-checkbox label="Set as Default" formControlName="defaultPaymentMethod" [binary]="true" id="default"></p-checkbox>
              <div class="ms-4 mt-2">
                If you set this new payment method as the default, all your
                Auto-renew orders will be charged using this payment method.
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-8 mb-3">
            <label for='consent' class="required" id="consentLabel">
              <p-checkbox label="Consent" formControlName="consent" [binary]="true" id="consent" #consent=></p-checkbox>
            </label>
            <div *ngIf="form.get('ach.consent')?.errors?.required && form.get('ach.consent')?.touched" class="mb-3 col-md-14">
              <span class="text-danger">Please read the Consent Agreement regarding ACH withdrawals and click on the box to accept.</span>
            </div>
            <div class="ms-4 mt-2 small">
              I hereby authorize the payee to electronically debit my bank account for payments to
              the Short Code Registry not to exceed the amount
              specified as the Maximum Payment Limit.
              <br>
              <br>
              If a convenience fee is added to the transaction, I understand that the convenience
              fee will be included in the total payment amount.
              <br>
              <br>
              If a payment is returned for insufficient funds, I authorize the payee to
              electronically debit my account for the original amount of
              the transaction, as well as a returned item fee, up to the maximum amount allowed by
              law.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>